import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { MessageBubble } from './MessageBubble';
const ChatWindow = ({ messages, limit, chatMode, chatHeight, }) => {
    const displayedMessages = limit ? messages.slice(0, limit) : messages;
    const chatRef = useRef(null);
    const heightClass = chatHeight ? `h-[${chatHeight}]` : 'h-96';
    useEffect(() => {
        if (chatMode && chatRef.current) {
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
        }
    }, [displayedMessages, chatMode]);
    return (_jsx("div", { ref: chatMode ? chatRef : null, className: `max-w-3xl p-4 overflow-y-auto ${chatMode ? `${heightClass}` : ''}`, children: displayedMessages.length > 0 ? ((chatMode ? [...messages].reverse() : displayedMessages).map((msg) => (_jsx(MessageBubble, { message: msg }, msg.id)))) : (_jsx("div", { className: "text-center text-gray-500", children: "No messages yet." })) }));
};
export { ChatWindow };
